import { useCallback } from "react";
import { Country } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { TrackingEventCategory, useEmitUserEvent } from "@lookiero/sty-psp-tracking";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { BackToTopSection, BackToTopTrackingEvent, TrackingEventName } from "./tracking";

interface TrackBackToTopFunctionArgs {
  readonly section: BackToTopSection;
}

interface TrackBackToTopFunction {
  (args: TrackBackToTopFunctionArgs): void;
}

interface UseTrackBackToTopFunctionArgs {
  readonly country: Country;
  readonly segment: Segment;
  readonly userId: string;
  readonly tradename: Tradename;
}

interface UseTrackBackToTopFunction {
  (agrs: UseTrackBackToTopFunctionArgs): TrackBackToTopFunction;
}

const useTrackBackToTop: UseTrackBackToTopFunction = ({ country, segment, tradename, userId }) => {
  const emitUserEvent = useEmitUserEvent<BackToTopTrackingEvent>();

  const trackBackToTop: TrackBackToTopFunction = useCallback(
    ({ section }) => {
      emitUserEvent({
        event: TrackingEventName.BACK_TO_TOP,
        eventCategory: TrackingEventCategory.LOOK_IN,
        store: country,
        section,
        segment,
        tradename,
        userId,
        userUuid: userId,
      });
    },
    [country, emitUserEvent, segment, tradename, userId],
  );

  return trackBackToTop;
};

export { useTrackBackToTop };
